<template>

<div>

  <div v-if="extra">

    <h1>Extra: {{ extra.name }}</h1>

    <div class="box">

      <Errors/>

      <form class="form" v-on:submit.prevent="updateExtra">

        <ExtraFields/>

        <div class="form-wrap form-submit">
          <div v-if="this.getLoadStatus">
            <button type="submit" class="button" disabled><span>Updating...</span></button>
          </div>
          <div v-else>
            <button type="submit" class="button" v-if="userRole == 1"><span>Update extra</span></button>
          </div>
        </div>

      </form>

    </div>

  </div>

</div>

</template>

<script>
import ExtraFields from '@/components/ExtraFields.vue'
import Errors from '@/components/Errors.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'ExtraEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    },
  },
  data () {
    return {
      extra: null,
      errors: null,
      selectedAirlines : [],
      selectedTours:[]
    }
  },
  components: {
    ExtraFields,
    Errors
  },
  created () {
    this.getExtra()
  },
  watch: {
    '$route': 'getExtra'
  },
  methods: {
    getExtra () {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'extras/' + this.$route.params.id, {
        headers: {
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        this.extra = response.data
        if (this.extra.airlines.length > 0 ) {
          let This = this
          
          this.extra.airlines.forEach((element) => {
            This.selectedAirlines.push(element.item_id)
          })
        }

        if (this.extra.tours.length > 0 ) {
          let This = this
          
          this.extra.tours.forEach((element) => {
            This.selectedTours.push(element.item_id)
          })
        }

      })
    },
    updateExtra () {
      this.$store.dispatch('setLoadStatus')

      let requestObject = {
        extra : this.extra,
        airlines: this.selectedAirlines,
        tours:this.selectedTours
      }

      fetch(this.$api + 'extras/' + this.$route.params.id, {
        method: 'POST',
        body: JSON.stringify(requestObject),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        if(response.success) {
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    }
  }
}
</script>
